(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // State
  // Map<productId (string), variantId (number)>
  // ---------------------------------------------------------------------------
  var selectedVariants = new Map();

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------
  function getItemEl(productId) {
    return document.querySelector('.complete-products__item[data-product-id="' + productId + '"]');
  }

  function getVariantInput(itemEl) {
    return itemEl && itemEl.querySelector('.complete-products__variant-id');
  }

  function isItemAvailable(itemEl) {
    var input = getVariantInput(itemEl);
    return input && input.dataset.available === 'true';
  }

  // ---------------------------------------------------------------------------
  // Variant dropdowns
  // ---------------------------------------------------------------------------
  function initVariantDropdowns() {
    document.querySelectorAll('.complete-products__variant-select').forEach(function (dropdown) {
      var selected  = dropdown.querySelector('.complete-products__variant-select__selected');
      var current   = dropdown.querySelector('.complete-products__variant-select__current');
      var optionsList = dropdown.querySelector('.complete-products__variant-select__options');
      var priceEl   = dropdown.closest('.complete-products__item-body') &&
                      dropdown.closest('.complete-products__item-body').querySelector('[data-price]');
      var hiddenInput = dropdown.querySelector('.complete-products__variant-id');
      var itemEl    = dropdown.closest('[data-addon-item]');

      if (!selected || !optionsList || !hiddenInput) return;

      // Toggle open/close
      selected.addEventListener('click', function () {
        optionsList.classList.toggle('open');
      });

      // Option selection
      optionsList.querySelectorAll('.complete-products__variant-option').forEach(function (option) {
        option.addEventListener('click', function () {
          var available = option.dataset.available === 'true';

          // Update display
          current.textContent = option.textContent.trim();

          // Update price
          if (priceEl && option.dataset.price) {
            priceEl.textContent = option.dataset.price;
          }

          // Update hidden input
          hiddenInput.value = option.dataset.variantId;
          hiddenInput.dataset.available = option.dataset.available;

          // Sync the selectedVariants map if this item is already checked
          var pid = itemEl && itemEl.dataset.productId;
          if (pid && selectedVariants.has(pid)) {
            selectedVariants.set(pid, parseInt(option.dataset.variantId, 10));
          }

          optionsList.classList.remove('open');

          // If currently selected and new variant is sold out, deselect
          if (itemEl && itemEl.classList.contains('complete-products__item--selected') && !available) {
            deselect(itemEl);
          }

          // Update unavailable visual on the item
          if (itemEl) {
            if (available) {
              itemEl.classList.remove('complete-products__item--unavailable');
            } else {
              itemEl.classList.add('complete-products__item--unavailable');
            }
          }
        });
      });

      // Close on outside click
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          optionsList.classList.remove('open');
        }
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Selection (checkbox / radio)
  // ---------------------------------------------------------------------------
  function select(itemEl) {
    var productId = itemEl.dataset.productId;
    var input     = getVariantInput(itemEl);
    if (!input) return;
    var variantId = parseInt(input.value, 10);
    itemEl.classList.add('complete-products__item--selected');
    selectedVariants.set(productId, variantId);
  }

  function deselect(itemEl) {
    var productId = itemEl.dataset.productId;
    itemEl.classList.remove('complete-products__item--selected');
    selectedVariants.delete(productId);
  }

  function toggleItem(itemEl) {
    if (!isItemAvailable(itemEl)) return;
    if (itemEl.classList.contains('complete-products__item--selected')) {
      deselect(itemEl);
    } else {
      select(itemEl);
    }
  }

  function initCheckboxes() {
    document.querySelectorAll('[data-addon-item]').forEach(function (itemEl) {
      itemEl.addEventListener('click', function (e) {
        // Ignore clicks on the dropdown, learn-more button, or modal
        if (
          e.target.closest('.complete-products__variant-select') ||
          e.target.closest('[data-learn-more]') ||
          e.target.closest('.complete-products__modal')
        ) return;
        toggleItem(itemEl);
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Capture-phase ATC intercept
  // ---------------------------------------------------------------------------
  function initATCIntercept() {
    document.addEventListener('click', function (e) {
      // Only intercept if there are selected add-ons
      if (selectedVariants.size === 0) return;

      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      // Do not intercept clicks that originate inside the widget itself
      if (btn.closest('[data-complete-products]')) return;

      e.stopPropagation();
      e.preventDefault();

      // Find main product variant ID from the enclosing form
      var form = btn.closest('form');
      var variantInput = form &&
        form.querySelector('select[name="id"], input[name="id"][type="hidden"], input[name="id"]');
      var mainVariantId = variantInput ? parseInt(variantInput.value, 10) : NaN;

      if (!mainVariantId || isNaN(mainVariantId)) {
        console.warn('[complete-products] Could not determine main product variant. Clearing add-on selections — click Add to Cart again.');
        selectedVariants.clear();
        document.querySelectorAll('.complete-products__item--selected').forEach(function (el) {
          el.classList.remove('complete-products__item--selected');
        });
        return;
      }

      // Build items array: main product first, then all selected add-ons
      var addonItems = [];
      selectedVariants.forEach(function (variantId) {
        addonItems.push({ id: variantId, quantity: 1 });
      });

      var items = [{ id: mainVariantId, quantity: 1 }].concat(addonItems);

      // Button loading state
      btn.classList.add('btn--loading');
      var textEl = btn.querySelector('[data-add-to-cart-text]');
      if (textEl) textEl.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) { throw err; });
          }
          return response.json();
        })
        .then(function (data) {
          btn.classList.remove('btn--loading');
          if (textEl) textEl.textContent = textEl.dataset.defaultText || 'Add to Cart';

          // Clear all selections
          selectedVariants.clear();
          document.querySelectorAll('.complete-products__item--selected').forEach(function (el) {
            el.classList.remove('complete-products__item--selected');
          });

          // Trigger cart drawer via existing theme event
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: btn }
          }));
        })
        .catch(function (err) {
          btn.classList.remove('btn--loading');
          if (textEl) textEl.textContent = textEl.dataset.defaultText || 'Add to Cart';
          console.error('[complete-products] Cart add failed:', err);
        });

    }, true); // capture phase — fires before bubble-phase handlers
  }

  // ---------------------------------------------------------------------------
  // Modal image carousel — show/hide frames, no transforms needed
  // ---------------------------------------------------------------------------
  function initModalCarousels() {
    document.querySelectorAll('[data-modal-carousel]').forEach(function (carousel) {
      var frames  = Array.from(carousel.querySelectorAll('.complete-products__modal-image-frame'));
      var prevBtn = carousel.querySelector('[data-modal-prev]');
      var nextBtn = carousel.querySelector('[data-modal-next]');
      if (frames.length <= 1) return;

      var index = 0;

      function show(i) {
        frames.forEach(function (f, fi) {
          f.classList.toggle('complete-products__modal-image-frame--hidden', fi !== i);
        });
        if (prevBtn) prevBtn.setAttribute('aria-hidden', i === 0 ? 'true' : 'false');
        if (nextBtn) nextBtn.setAttribute('aria-hidden', i === frames.length - 1 ? 'true' : 'false');
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (index > 0) show(--index);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (index < frames.length - 1) show(++index);
        });
      }

      // Expose reset so openModal can return to slide 1 each time
      carousel._reset = function () { index = 0; show(0); };

      show(0); // set initial arrow state
    });
  }

  // ---------------------------------------------------------------------------
  // Modal
  // ---------------------------------------------------------------------------
  function openModal(modal) {
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    // Reset carousel to first image every time modal opens
    var carousel = modal.querySelector('[data-modal-carousel]');
    if (carousel && typeof carousel._reset === 'function') carousel._reset();
    var closeBtn = modal.querySelector('[data-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function getOpenModal() {
    return document.querySelector('.complete-products__modal:not([hidden])');
  }

  function initModals() {
    // Learn More button → open modal
    document.querySelectorAll('[data-learn-more]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var targetId = btn.dataset.modalTarget;
        if (targetId) openModal(document.getElementById(targetId));
      });
    });

    // Close triggers (overlay click, close button)
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-modal-close]')) return;
      var modal = e.target.closest('.complete-products__modal');
      if (modal) closeModal(modal);
    });

    // Modal "Add to Cart" → select item + close modal
    document.querySelectorAll('[data-modal-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var productId = btn.dataset.productId;
        var itemEl    = getItemEl(productId);
        if (itemEl && !itemEl.classList.contains('complete-products__item--selected')) {
          toggleItem(itemEl);
        }
        var modal = document.getElementById('complete-products-modal-' + productId);
        closeModal(modal);
      });
    });

    // Escape key closes modal
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var modal = getOpenModal();
        if (modal) closeModal(modal);
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('[data-complete-products]')) return;
    initVariantDropdowns();
    initCheckboxes();
    initATCIntercept();
    initModalCarousels();
    initModals();
  });

})();
